import { supabase } from '../supabaseClient';
import { User } from '../types/models';

const fetchAndMapUser = async (supabaseUser: any): Promise<User | null> => {
    if (!supabaseUser) return null;

    const { data: profile, error } = await supabase
        .from('profiles')
        .select('first_name, last_name, role, login')
        .eq('id', supabaseUser.id)
        .single();
    
    if (error) {
        console.error("Błąd pobierania profilu użytkownika:", error);
        return {
            id: supabaseUser.id,
            login: supabaseUser.user_metadata?.login || supabaseUser.email || '',
            firstName: supabaseUser.user_metadata?.first_name || 'Brak',
            lastName: supabaseUser.user_metadata?.last_name || 'Imienia',
            role: supabaseUser.user_metadata?.role || 'kursant',
        };
    }

    return {
        id: supabaseUser.id,
        login: profile.login,
        firstName: profile.first_name,
        lastName: profile.last_name,
        role: profile.role,
    };
};

export const authService = {
  getCurrentUser: async (): Promise<User | null> => {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user) return null;
    return await fetchAndMapUser(session.user);
  },

  login: async (loginInput: string, password: string): Promise<User> => {
    let emailToLogin = loginInput;

    if (!loginInput.includes('@')) {
      const { data: profile, error } = await supabase
        .from('profiles')
        .select('email')
        .eq('login', loginInput)
        .single();
        
      if (error || !profile?.email) {
        throw new Error('Nieprawidłowy login lub hasło');
      }
      emailToLogin = profile.email;
    }
    
    const { data, error: authError } = await supabase.auth.signInWithPassword({
      email: emailToLogin,
      password: password,
    });

    if (authError) throw new Error('Nieprawidłowy login lub hasło');
    if (!data.user) throw new Error('Nie udało się zalogować.');
    
    const appUser = await fetchAndMapUser(data.user);
    if (!appUser) throw new Error('Nie udało się pobrać danych profilu po zalogowaniu.');
    
    return appUser;
  },
  
  logout: async (): Promise<void> => {
    await supabase.auth.signOut();
  },
  
  createUser: async (
    login: string,
    password: string, 
    firstName: string, 
    lastName: string
  ) => {
    const { error } = await supabase.rpc('create_student_user', {
      p_login: login,
      p_password: password,
      p_first_name: firstName,
      p_last_name: lastName
    });

    if (error) {
      console.error("Błąd RPC przy tworzeniu użytkownika:", error);
      if (error.message.includes('duplicate key value violates unique constraint')) {
          throw new Error('Użytkownik z takim loginem lub e-mailem już istnieje.');
      }
      throw new Error(`Nie udało się stworzyć użytkownika: ${error.message}`);
    }
  }
};